import { useReducer, createContext, useEffect, useState } from 'react'
import { useRouter } from 'next/router'

import { checkpriceFormReducer } from './reducers/checkpriceForm'
import { isOldWorld } from '../utils/isOldWorld'

const initialState = {
  checkpriceForm: {},
  checkpriceMode: '',
  isFromApp: false,
  onRouting: undefined,
}

const Context = createContext({})

const combineReducers = (...reducers) => (state, action) => {
  for (let i = 0; i < reducers.length; i++) state = reducers[i](state, action);
  return state;
}

const Provider = ({ children }) => {
  const router = useRouter()

  const [state, dispatch] = useReducer(combineReducers(checkpriceFormReducer), initialState)

  const [isFromApp, setIsFromApp] = useState(false)

  const handleRouting = (pathname, query = undefined, options = { isReplace: false, locale: null, shallow: false }) => {
    let target = ''
    const { isReplace, locale, shallow } = options

    if (isFromApp) {
      target = `${pathname}?shippop_app`

      if (query) {
        target = `${target}&${query}`
      }
    } else if (query) {
      target = `${pathname}?${query}`
    } else {
      target = pathname
    }

    // Keep old-world self-re-routes in the old world: append `old` to the
    // QUERY part (before any #hash) unless the target already carries it —
    // splitting off the hash first so we never corrupt an in-page anchor.
    if (isOldWorld(router)) {
      const hashIdx = target.indexOf('#')
      const base = hashIdx === -1 ? target : target.slice(0, hashIdx)
      const hash = hashIdx === -1 ? '' : target.slice(hashIdx)
      if (!/[?&]old(=|&|$)/.test(base)) {
        target = base + (base.includes('?') ? '&' : '?') + 'old' + hash
      }
    }

    if (isReplace) {
      router.replace(target, target, { locale, shallow })
    } else {
      router.push(target, target, { locale, shallow })
    }
  }

  
  useEffect(() => {
    const { query } = router
    let hasShippopApp = false
    
    Object.keys(query).forEach((k) => {
      if (k === 'shippop_app') {
        hasShippopApp = true
      }
    })

    setIsFromApp(hasShippopApp)
  }, [])

  const value = { state, dispatch, onRouting: handleRouting, isFromApp }
  
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { Context, Provider }